/**
 * Helper isolado pro `VITE_GOOGLE_CLIENT_ID` — fica fora do componente
 * `GoogleLoginProvider` por causa da regra react-refresh/only-export-components
 * (componente + helper no mesmo arquivo quebra HMR).
 */
export function getGoogleClientId(): string | null {
  return (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? null;
}
